import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card} from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import {crudGetOne as crudGetOneAction} from '../admin/dataActionsInventoryTransfer';
import DefaultActions from 'admin-on-rest/lib/mui/detail/ShowActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

export class ShowInventoryTransfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: {},
            transferId: null,
        };
    }

    componentDidMount() {
        this.updateData(this.props);
    }

    getBasePathUpOne() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -3)
            .join('/');
    }

    extractDataFromPath() {
        const {location} = this.props;
        const pathArray = location.pathname.split('/');
        const transferType = pathArray[2];
        return {
            'resource': pathArray[1],
            'transfer_type': pathArray[2],
            'location_id': (transferType === 'memo') ? '' : pathArray[3],
            'transfer_id': (transferType === 'memo') ? pathArray[3] : pathArray[4],
        };
    }

    updateData(props) {
        const path = this.extractDataFromPath();
        const pathProps = {
            'location_id': path.location_id,
            'transfer_id': path.transfer_id,
            data: {
                'location_id': path.location_id,
                'transfer_id': path.transfer_id,
            }
        };
        this.setState({record: pathProps.data});
        this.props.crudGetOne(props.resource, pathProps.location_id, pathProps.transfer_id, this.getBasePathUpOne());
    }

    render() {
        const {
            actions = <DefaultActions/>,
            title,
            children,
            id,
            data,
            desc,
            isLoading,
            resource,
            hasList,
            translate,
            version,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePathUpOne();

        const transferId = this.state.transferId;
        if (transferId) {
            data.transfer_id = transferId;
        }

        const resourceName = translate(`resources.${resource}.name`, {
            smart_count: 1,
            _: inflection.humanize(inflection.singularize(resource)),
        });
        const defaultTitle = translate('aor.page.show', {
            name: `${resourceName}`,
            id,
            data,
        });
        const titleElement = data ? (
            <Title title={title} record={data} defaultTitle={defaultTitle}/>
        ) : (
            ''
        );
        const descriptionElement = data ? (
            <PageDescription record={data} desc={desc}/>
        ) : (
            ''
        );

        return (
            <div>
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        data,
                        hasList,
                        resource,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {data &&
                    React.cloneElement(children, {
                        resource,
                        basePath,
                        record: data,
                        translate,
                        version,
                    })}
                </Card>
            </div>
        );
    }
}

ShowInventoryTransfer.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudGetOne: PropTypes.func.isRequired,
    data: PropTypes.object,
    desc: PropTypes.any,
    hasList: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func,
    version: PropTypes.number.isRequired,
};

function mapStateToProps(state, props) {
    return {
        id: decodeURIComponent(props.match.params.id),
        data: state.admin.resources[props.resource]
            ? state.admin.resources[props.resource].data[
                decodeURIComponent(props.match.params.id)
                ]
            : null,
        isLoading: state.admin.loading > 0,
        version: state.admin.ui.viewVersion,
    };
}

const enhance = compose(
    connect(mapStateToProps, {crudGetOne: crudGetOneAction}),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(ShowInventoryTransfer);



// WEBPACK FOOTER //
// ./src/Fuse/admin/ShowInventoryTransfer.js